/**
 * Generated template: Simple Ranking
 * Auto-generated by scripts/generate-templates.js - DO NOT EDIT
 */

import { TierListTemplate, Tier } from "@/types/tier-list";
import { TemplateMetadata } from "@/types/template-metadata";

/**
 * Template metadata (available immediately, no images loaded)
 */
export const metadata: TemplateMetadata = {
  id: "simple-ranking",
  displayName: "Simple Ranking",

  description: "Simple 1st through 5th place ranking",
  tiers: [
  {
    "id": "tier-1st",
    "label": "1st",
    "priority": 0,
    "color": {
      "label": "#000000",
      "background": "#FCD34D"
    },
    "fontSizeMultiplier": 2
  },
  {
    "id": "tier-2nd",
    "label": "2nd",
    "priority": 1,
    "color": {
      "label": "#FFFFFF",
      "background": "#7C3AED"
    },
    "fontSizeMultiplier": 2
  },
  {
    "id": "tier-3rd",
    "label": "3rd",
    "priority": 2,
    "color": {
      "label": "#FFFFFF",
      "background": "#2563EB"
    },
    "fontSizeMultiplier": 2
  },
  {
    "id": "tier-4th",
    "label": "4th",
    "priority": 3,
    "color": {
      "label": "#FFFFFF",
      "background": "#16A34A"
    },
    "fontSizeMultiplier": 2
  },
  {
    "id": "tier-5th",
    "label": "5th",
    "priority": 4,
    "color": {
      "label": "#FFFFFF",
      "background": "#EA580C"
    },
    "fontSizeMultiplier": 2
  }
] as Tier[],
  hasItems: false,
};

/**
 * Load full template with all data including images
 * This is lazy-loaded only when the template is selected
 */
export async function loadFull(): Promise<TierListTemplate> {
  // Dynamic import loads the full JSON only when called
  const fullTemplate = await import("@/templates/simple-ranking.json");
  return fullTemplate.default as TierListTemplate;
}
